import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  navMenu: {
    padding: "20px 10px 15px 10px",
  },
  drawer: {
    width: "100%",
    "& .MuiDrawer-paperAnchorDockedLeft": {
      width: "100%",
      position: "relative",
      backgroundColor: "#FBFBFC",
      borderRight: "none",
      overflow: "hidden",
    },
  },
  toolbar: {
    minHeight: "10px",
  },
}));
